import React from 'react';
import clsx from 'clsx';
import { Scrollbars } from 'react-custom-scrollbars';

import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import LoginFormTemplate from 'pages/templates/LoginFormTemplate';
import MainLogo from 'images/common/logo/logo_white.png';

const useStyles = makeStyles((theme) => ({
  customScroll: {
    position: 'fixed !important',
    '& > div': {
      backgroundColor: '#3a4652',
    },
  },
  loginWrap: {
    position: 'relative',
    maxWidth: '100%',
    boxSizing: 'border-box',
    margin: '100px auto 20px',
    border: 0,
    borderRadius: '2px',
  },

  formLogo: {
    width: '40%',
    maxWidth: 170,
    margin: '0 auto 30px',
    textAlign: 'center',
    '& img': {
      width: '100%',
    },
  },
  loginFormWrap: {
    display: 'block',
    width: 'calc(100% - 40px)',
    maxWidth: 500,
    margin: '0 auto',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    borderTop: '4px solid #85b74e',
    borderRadius: 4,
    fontSize: theme.spacing(2),
    verticalAlign: 'top',
    textAlign: 'left',
    '& form > div': {
      width: '90%',
      margin: '0 5%',
      '&:first-child': {
        marginTop: theme.spacing(5),
      },
    },
  },
}));

const LoginForm = ({
  form,
  error,
  saveId = false,
  onChange,
  onSubmit,
  children,
}) => {
  const tablet = useMediaQuery('(max-width: 768px)');
  const classes = useStyles();

  return (
    <Scrollbars
      autoHide
      autoHideTimeout={1000}
      autoHideDuration={200}
      className={classes.customScroll}
    >
      <LoginFormTemplate>
        <div className={classes.loginWrap}>
          <div className={classes.formLogo}>
            <Link href="/">
              <img src={MainLogo} alt="logo" />
            </Link>
          </div>
          <div className={clsx(classes.loginFormWrap, { tablet })}>
            {children}
          </div>
        </div>
      </LoginFormTemplate>
    </Scrollbars>
  );
};

export default LoginForm;
